import React, { useEffect } from 'react';
import Modal from './Modal.jsx';
import useExcelPreview from '../hooks/useExcelPreview';
import '../styles/ExcelPreviewModal.scss';

const ExcelPreviewModal = ({ isOpen, onClose, fetchUrl, title }) => {
  const { open, loading, error, sheetNames, activeSheet, setActiveSheet, rows, colWidths } = useExcelPreview(fetchUrl);

  useEffect(() => {
    if (isOpen) open();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, fetchUrl]);

  const [header, ...body] = rows;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title || 'Uploaded Data Sheet'} size="lg">
      {sheetNames.length > 1 && (
        <div className="excel-preview-tabs">
          {sheetNames.map((name) => (
            <button
              key={name}
              className={`excel-preview-tab ${name === activeSheet ? 'excel-preview-tab--active' : ''}`}
              onClick={() => setActiveSheet(name)}
            >
              {name}
            </button>
          ))}
        </div>
      )}

      {loading && <div className="excel-preview-status">Loading…</div>}
      {!loading && error && <div className="excel-preview-status excel-preview-status--error">{error}</div>}
      {!loading && !error && rows.length === 0 && (
        <div className="excel-preview-status">This sheet is empty.</div>
      )}

      {!loading && !error && rows.length > 0 && (
        <div className="excel-preview-table-wrap">
          <table className="excel-preview-table">
            <colgroup>
              {header.map((_, i) => (
                <col key={i} style={{ width: `${colWidths[i] || 80}px` }} />
              ))}
            </colgroup>
            <thead>
              <tr>
                {header.map((cell, i) => (
                  <th key={i}>{cell}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {body.map((row, ri) => (
                <tr key={ri}>
                  {row.map((cell, ci) => (
                    <td key={ci}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Modal>
  );
};

export default ExcelPreviewModal;
